import { Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LocaleService } from 'angular-l10n';
import { getLanguageSelector } from '@store/index';

@Component({
  selector: 'aff-translator',
  template: `<span l10nTranslate [ngStyle]="options">{{ text }}</span>`
})

export class Translator {
  @Input() text: string = '';
  @Input() options: any = {};

  constructor(
    private store: Store<{language: any}>,
    private localeService: LocaleService
  ) {
    store.select(getLanguageSelector).subscribe(val => {
      this.localeService.setCurrentLanguage(val);
    });

  }

}
